/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cool_Dark_Fox_ScanInputs */

const en_cool_dark_fox_scan = /** @type {(inputs: Cool_Dark_Fox_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No segments configured yet.`)
};

const de_cool_dark_fox_scan = /** @type {(inputs: Cool_Dark_Fox_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Segmente konfiguriert.`)
};

/**
* | output |
* | --- |
* | "No segments configured yet." |
*
* @param {Cool_Dark_Fox_ScanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cool_dark_fox_scan = /** @type {((inputs?: Cool_Dark_Fox_ScanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cool_Dark_Fox_ScanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cool_dark_fox_scan(inputs)
	return de_cool_dark_fox_scan(inputs)
});